module.exports = __webpack_public_path__ + "static/img/image163.8f01d8b7.png";